export default (path, queryString) => {
  const greenhouseTrackingOnly =
    (queryString.includes('gh_src=') || queryString.includes('gh_jid=')) &&
    !queryString.includes('trk_location=careersBreadcrumb');

  const greenhouseAndBreadcrumbTracking =
    (queryString.includes('gh_src=') || queryString.includes('gh_jid=')) &&
    queryString.includes('trk_location=careersBreadcrumb');

  const addBreadcumbTracking = `${path}?trk_location=careersBreadcrumb`;

  if (queryString.includes('?')) {
    if (greenhouseTrackingOnly) {
      return `${path + queryString}&trk_location=careersBreadcrumb`;
    }
    if (greenhouseAndBreadcrumbTracking) {
      return `${path + queryString}`;
    }
    return addBreadcumbTracking;
  }
  return addBreadcumbTracking;
};
